import { DatePipe } from '@angular/common';
import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { API_URLS, ApiUrlService } from 'libs/ng-components/utils/src/lib/services/api-url.service';
import { BaseTableComponent } from '../../fiber-joints/base-table.component';

@Component({
  selector: 'ebw-monorepo-to-open-history-modal',
  templateUrl: './to-open-history-modal.component.html',
  styleUrls: ['./to-open-history-modal.component.scss'],
  providers: [DatePipe]
})
export class ToOpenHistoryModalComponent extends BaseTableComponent<any> implements OnInit {
  public segment_urn: string;
  public splice_closure_urn: string;

  @ViewChild('toOpenColTemplate', { static: true })
  toOpenColTemplate!: TemplateRef<any>;

  constructor(private _apiUrlService: ApiUrlService, @Inject(MAT_DIALOG_DATA) public data: any, private datePipe: DatePipe) {
    super();
    const { segment_urn, splice_closure_to_open_urn } = this.data.giunto;
    this.segment_urn = segment_urn;
    this.splice_closure_urn = splice_closure_to_open_urn;
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.init();
  }

  protected fetchData(): void {
    this.resetComponentProperties();
    const baseUrl = this._apiUrlService.createUrl(API_URLS.CHECKIN.STORICO_TO_OPEN);
    const url = `${baseUrl}?segment_urn=${this.segment_urn}&splice_closure_urn=${this.splice_closure_urn}`;
    this._utilsService.getRequest(url).subscribe({
      next: (resp: any) => (this.dataGrid = resp),
      error: (err) => {
        this._ebwModal.openErrorModal({
          title: this._translateService.instant('common.error'),
          content: err.message
        });
      }
    });
  }

  protected initializeTable(): void {
    this.columnsGrid = [
      {
        header: 'Applicazione',
        field: 'application',
        sortable: false
      },
      {
        header: 'Data',
        field: 'created_at',
        sortable: false,
        formatter: (el) => this.datePipe.transform(el.created_at, 'dd/MM/yyyy HH:mm')
      },
      {
        header: 'Da aprire',
        field: 'to_open',
        cellTemplate: this.toOpenColTemplate
      }
    ];
  }

  protected getFilters(): Record<string, any> {
    return {};
  }
  protected formatExportData(data: any[], excel: boolean = false) {
    this.defaultFormatData(data, excel);
  }
}
